
export default function canUseState(array, iteration, attributeArray, attributeItenration) {
  const canUse = array.filter((item) => (item[attributeArray] === iteration[attributeItenration]))[0];
  return Boolean(canUse);
}
